import { swSettings } from "app/common/services/swSettings";
import { SwRedux } from "app/services/SwRedux";
import { PreferencesService } from "app/services/preferences/preferencesService";
import { PrimaryNavOverrideMode } from "app/reducers/_reducers/primaryNavOverrideReducer";
import type { NavigatorType } from "single-spa/react-app/ProNavigator";
import type { IRouterState } from "single-spa/react-app/router/IRouterState";
import { EAvailabilityMode } from "app/common/services/pageClaims";

export type Solutions2Package =
    | "digitalsuite"
    | "salesIntelligence"
    | "appIntelligence"
    | "workspace"
    | "dashboards"
    | "legacy";

const swRedux = SwRedux.getInstance();
const SOLUTION_GENERATION_PREFERENCE_KEY = "solutionGeneration";

const userSolutionMode = () => PreferencesService.get(SOLUTION_GENERATION_PREFERENCE_KEY) ?? PrimaryNavOverrideMode.S2;

const isOptedInUser = () => {
    return swSettings?.user?.hasSolution25OptIn && userSolutionMode() === PrimaryNavOverrideMode.S25;
};
export const isOptedInToDigitalSuite = () => {
    const internalNavOverrideMode = swRedux.getState()?.primaryNavOverride?.navOverrideMode;

    const isInternalUserS25Selected = internalNavOverrideMode === PrimaryNavOverrideMode.S25;
    return (
        isOptedInUser() ||
        (swSettings?.user?.hasSolution25 && (!swSettings?.user?.isSimilarWebUser || isInternalUserS25Selected))
    );
};

export const isPremiumFeatureAllowed = () => {
    return swSettings?.components?.PremiumSection?.resources?.AvaliabilityMode === EAvailabilityMode.OPEN;
};

/**
 * Checks if the user has access to the specified package name.
 * this is a solutions 2.0 extention, that checks which packages the user has access to.
 */
export const hasAccessToPackage = (packageName: Solutions2Package): boolean => {
    switch (packageName) {
        case "digitalsuite":
            return (swSettings?.user?.hasMR && swSettings?.user?.hasDM) || isOptedInToDigitalSuite();

        case "salesIntelligence":
            return swSettings?.user?.isSimilarWebUser || swSettings?.user?.hasSI;

        case "appIntelligence":
            return swSettings?.components?.AppAnalysisHome?.isAllowed;

        case "workspace":
        case "dashboards":
        case "legacy":
            return true;

        // If we have no package name for the current state, we need to assume
        // that the user has access to it. this is done to have backward compatibility
        // with states that were not-yet tagged under a package name.
        default:
            return true;
    }
};

/**
 * Checks if the current state belongs to a package that the user has access to.
 */
// TODO: RIPNG - i removed navigator type... do we need it?
export const hasAccessToState = (state: IRouterState, navigator: NavigatorType): boolean => {
    const statePackage = navigator.getPackageName(state);
    return !statePackage || hasAccessToPackage(statePackage);
};

/**
 * Sales 2.0 users go to old workspace;
 */

export const getRestrictionsPathForSI = (toState: IRouterState) => {
    const path = `/${toState.parent}${toState.url}`;

    if (path.startsWith("/home/modules")) {
        return "home_page";
    }

    if (path.startsWith("/workspace/sales")) {
        return "workspace";
    }

    return "";
};

const isBundleUser = () => swSettings?.user?.hasDS; // Digital Suite users
